import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { placeCreatedRowFirst } from "utils/helpers";
import { AdminPriceListMeta, AdminPriceState, adminPriceTableRow, AdminTableFormState, itemNameDropDown } from "../types/index";
import { initialFormState, initialState } from "./initialState";

export const sliceKey = "AdminPriceState";

type AdminPriceListSuccessPayload = {
  data: adminPriceTableRow[];
  meta: AdminPriceListMeta;
};

export const adminPriceSlice = createSlice({
  name: sliceKey,
  initialState: initialState,
  reducers: {
    getPriceList: (state) => {
      state.loading = true;
      state.error = null;
      state.page = 1;
    },
    getPriceListSuccess: (state, action: PayloadAction<AdminPriceListSuccessPayload>) => {
      state.loading = false;
      state.priceData = action.payload.data;
      state.meta = action.payload.meta;
      state.page = action.payload.meta.currentPage;
      state.error = null;
    },
    getPriceListFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    getNextPageItems: (state) => {
      if (state.loading || state.meta.currentPage >= state.meta.totalPages) {
        return;
      }
      state.loading = true;
      state.error = null;
      state.page = state.meta.currentPage + 1;
    },
    getNextPageItemsSuccess: (state, action: PayloadAction<AdminPriceListSuccessPayload>) => {
      state.loading = false;
      state.priceData = state.priceData.concat(action.payload.data);
      state.meta = action.payload.meta;
      state.page = action.payload.meta.currentPage;
      state.error = null;
    },
    getNextPageItemsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    setFormField: (state, action: PayloadAction<Partial<AdminTableFormState>>) => {
      state.form = { ...state.form, ...action.payload };
    },
    openAddModal: (state) => {
      state.isAddModalOpen = true;
      state.form = { ...initialFormState };
    },

    closeAddModal: (state) =>
      { state.isAddModalOpen = false; },
    
    getModalDropDowns: ()=>
      {},

    getModalDropDownsSuccses: (state,action: PayloadAction<itemNameDropDown[]>)=>
      {state.itemNameDropDown = action.payload
       state.loading = false
      },

    getModalDropDownsFailer: (state,action: PayloadAction<string>)=>
      {state.error = action.payload
       state.loading = false
      },

    resetForm: (state) =>
      { state.form = initialFormState; },

    craeteForm: (state, _action: PayloadAction<AdminTableFormState>) => {
      state.loading = true;
    },
    createPriceListSuccess: (state, action: PayloadAction<adminPriceTableRow>) => {
      state.loading = false;
      state.priceData = placeCreatedRowFirst(state.priceData, action.payload);
      state.form = initialFormState;
    },
    createPriceListFailed: (state) => {
      state.loading = false;
    },

    setSelectedId: (state, action: PayloadAction<number>) => {
      state.selectedId = action.payload;
    },

    getPriceDetails: (state, action: PayloadAction<number>) => {
      state.loading = true;
      state.selectedId = action.payload;
    },
    getPriceDetailsSuccess: (state, action: PayloadAction<adminPriceTableRow>) => {
      state.loading = false;
      const idx = state.priceData.findIndex(row => row.priceTableId === action.payload.priceTableId);
      if (idx !== -1) state.priceData[idx] = action.payload;
    },
    getPriceDetailsFailure: (state) => {
      state.loading = false;
    },

    updatePrice: (state, action: PayloadAction<{ id: number; form: AdminTableFormState }>) => {
      state.loading = true;
      state.selectedId = action.payload.id;
    },
    updatePriceSuccess: (state, action: PayloadAction<adminPriceTableRow>) => {
      state.loading = false;
      const idx = state.priceData.findIndex(row => row.priceTableId === action.payload.priceTableId);
      if (idx !== -1) state.priceData[idx] = action.payload;
    },
    updatePriceFailure: (state) => {
      state.loading = false;
    },

    deletePrice: (state, action: PayloadAction<number>) => {
      state.loading = true;
      state.selectedId = action.payload;
    },
    deletePriceSuccess: (state, action: PayloadAction<number>) => {
      state.loading = false;
      state.priceData = state.priceData.filter(row => row.priceTableId !== action.payload);
      state.selectedId = 0;
    },
    deletePriceFailure: (state) => {
      state.loading = false;
    },
  },
})

export const { reducer, actions } = adminPriceSlice